export const isDebug = JSON.parse(import.meta.env.PUBLIC_DEBUG)
